import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { Droppable } from 'react-beautiful-dnd';
import { useDndContext } from '../DndContext/DndContext.js';
import { DndPlaceholder } from '../DndContext/DndPlaceholder.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var _excluded = ["children", "droppableId", "hidePlaceholder", "placeholderStyle"];
var DndDroppable = function DndDroppable(_ref) {
  var _children = _ref.children,
    droppableId = _ref.droppableId,
    hidePlaceholder = _ref.hidePlaceholder,
    _ref$placeholderStyle = _ref.placeholderStyle,
    placeholderStyle = _ref$placeholderStyle === void 0 ? {} : _ref$placeholderStyle,
    droppableProps = _objectWithoutProperties(_ref, _excluded);
  var dndContext = useDndContext();
  var isPlaceholderVisible = function isPlaceholderVisible() {
    if (hidePlaceholder || !(dndContext !== null && dndContext !== void 0 && dndContext.placeholderProps)) {
      return false;
    }
    var hasTarget = !!dndContext.placeholderProps.targetDroppableId;
    return !hasTarget && dndContext.placeholderProps.sourceDroppableId === droppableId || hasTarget && dndContext.placeholderProps.targetDroppableId === droppableId;
  };
  var placeholderDisplayStyle = isPlaceholderVisible() ? "block" : "none";
  return /*#__PURE__*/jsx(Droppable, _objectSpread(_objectSpread({}, droppableProps), {}, {
    droppableId: droppableId,
    children: function children(provided) {
      return /*#__PURE__*/jsxs("div", {
        style: {
          position: "relative"
        },
        children: [/*#__PURE__*/jsx("div", _objectSpread(_objectSpread({}, provided.droppableProps), {}, {
          ref: provided.innerRef,
          children: _children
        })), !hidePlaceholder && /*#__PURE__*/jsxs("div", {
          id: "_mntl-placeholder-".concat(droppableId),
          style: {
            display: placeholderDisplayStyle,
            position: "relative",
            height: 1
          },
          children: [provided.placeholder, !!(dndContext !== null && dndContext !== void 0 && dndContext.placeholderProps) && /*#__PURE__*/jsx(DndPlaceholder, {
            props: dndContext.placeholderProps,
            style: placeholderStyle
          })]
        }), /*#__PURE__*/jsx("div", {
          style: {
            display: placeholderDisplayStyle
          },
          children: provided.placeholder
        })]
      });
    }
  }));
};
DndDroppable.displayName = "DndDroppable";

export { DndDroppable };
